<template>
	<div>
		<q-dialog v-model="show_podcast_details" maximized>
			<q-card class="card-main bg-black text-white">
				<q-toolbar>
					<q-toolbar-title></q-toolbar-title>
					<q-btn
						flat
						round
						dense
						icon="fal fa-times"
						@click="show_podcast_details = false"
					/>
				</q-toolbar>

				<q-separator />

				<q-card-section class="q-pa-md">
					<div class="row q-col-gutter-lg">
						<div class="col-6">
							<q-img :src="getImage" @error="getImageError" class="rounded-borders" />
						</div>

						<div class="col-6">
							<span class="title text-weight-bold q-mb-sm">{{ podcast.title }}</span>
							<span class="col-12 description text-body2 text-grey-6">
								{{ podcast.podcast_playlist_audio.length }}
								{{
									$t('episode', { count: podcast.podcast_playlist_audio.length })
								}}
							</span>
							<div class="row q-col-gutter-sm justify-end">
								<div class="col-6">
									<q-btn
										class="full-width"
										block
										icon="fas fa-play"
										color="positive"
										@click="playEpisodes(0)"
									/>
								</div>
								<div class="col-6">
									<q-btn
										class="full-width"
										:disable="playlist.length > 0 ? false : true"
										color="primary"
										icon="fas fa-plus"
										@click="show_modal_playlist = true"
									/>
								</div>
							</div>
						</div>

						<div class="col-sm-8 col-lg-9">
							<div class="row justify-between full-height q-col-gutter-sm">
								<div class="col-12 description text-body2 text-grey-6">
									{{ podcast.description }}
								</div>

								<div v-if="podcast.unpublish_date">
									<p>
										<em>{{
											`${$t('content_deadline')} ${$dateUtil.fDate(
												podcast.unpublish_date
											)}.`
										}}</em>
									</p>
								</div>
							</div>
						</div>
						<div class="col-12">
							<div class="flex justify-center"></div>
						</div>
						<div class="col-12">
							<q-card
								class="bg-grey-10 q-mb-sm"
								v-for="(audio, index) in podcast.podcast_playlist_audio"
								:key="index"
							>
								<q-card-section>
									<div class="row flex items-center">
										<div class="col-4 flex">
											<q-checkbox dark v-model="teste" :val="audio.id" />
											<q-icon
												name="fal fa-play-circle"
												size="lg"
												color="white"
												@click="playEpisodes(audio.id)"
											/>
										</div>

										<div class="col-8 q-pl-sm text-white">
											<div class="q-mb-sm">
												<p class="q-mb-none title-audio text-weight-medium">
													{{ audio.title }}
													<br />
													<span class="date text-weight-light">{{
														$dateUtil.fDateNoTimezoneOpen(
															audio.created_date
														)
													}}</span>
												</p>
											</div>

											<div class="flex">
												<q-linear-progress
													rounded
													style="height: 4px"
													color="red-5"
													:value="
														audio.progress_audio_listen_status == 2
															? 100
															: audio.progress.toFixed(0) / 100
													"
												/>
											</div>
										</div>
									</div>
								</q-card-section>
							</q-card>
						</div>
					</div>
				</q-card-section>
			</q-card>
		</q-dialog>
		<added-playlist :show="show_modal_playlist" @closeModal="closeModal" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddedPlaylist from 'components/podcasts/mobile/AddedPlaylist'
export default {
	name: 'PodcastDetails',
	i18nOptions: { namespaces: ['custom', 'common', 'podcasts'] },
	components: {
		'added-playlist': AddedPlaylist,
	},

	data() {
		return {
			columns: [
				{ name: 'title', label: 'title', field: 'title', align: 'left' },
				{ name: 'progress', label: 'progress', field: 'progress', align: 'left' },
				{ name: 'date', label: 'date', field: 'date', align: 'left' },
				{ name: 'duration', label: 'duration', field: 'duration', align: 'left' },
			],
			podcast: {
				title: '',
				description: '',
				podcast_playlist_audio: [],
			},
			current_audio: {},
			show_podcast_details: false,
			show_modal_playlist: false,
		}
	},

	computed: {
		...mapGetters({
			playlist: 'podcasts/playlist',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getImage() {
			if (this.show_podcast_details === true) {
				let image = this.podcast.podcast_playlist_images.find((e) => e.name === 'original')
				if (image) return image.image_url
				else return 'placeholders/podcast.png'
			}
		},

		idCurrentAudio() {
			if (this.current_audio.id) return this.current_audio.id
			else ''
		},

		teste: {
			get() {
				return this.playlist
			},
			set(id) {
				this.$store.dispatch('podcasts/SET_PLAYLIST', [id])
			},
		},
	},

	methods: {
		openModal(e) {
			this.podcast = e.podcast
			this.current_audio = e.current_audio
			this.show_podcast_details = true
		},

		getImageError(event) {
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) {
				if (
					obj.podcast_placeholder !== 'https://image.jpg' &&
					obj.podcast_placeholder !== ''
				)
					event.target.src = obj.podcast_placeholder
				else event.target.src = 'placeholders/podcast.png'
			} else event.target.src = 'placeholders/podcast.png'
		},

		playEpisodes(position) {
			this.$mitt.emit('status', 'stopped')
			let index = this.podcast.podcast_playlist_audio.findIndex((e) =>
				e.id == position ? e : ''
			)
			let playlist = {
				podcast_id: this.podcast.id,
				title: this.podcast.title,
				audios: this.podcast.podcast_playlist_audio,
				position: index === -1 ? 0 : index,
				type_playlist: 'podcast',
			}
			this.$mitt.emit('playlist', playlist)
			this.$mitt.emit('status', 'playing')
			this.show_podcast_details = false
		},

		addUserPlaylist(podcast) {
			let has_id = this.playlist.includes(podcast.id)
			if (has_id) {
				let new_array = this.playlist.filter((e) => (e == podcast.id ? '' : e))
				this.$store.dispatch('podcasts/SET_PLAYLIST', [new_array])
			} else {
				let new_array = this.playlist.concat(podcast.id)
				this.$store.dispatch('podcasts/SET_PLAYLIST', [new_array])
			}
		},

		getClassline(id) {
			if (this.playlist.includes(id)) return 'bg-grey-8 q-mb-sm'
			else return ''
		},

		closeModal() {
			this.show_modal_playlist = false
		},
	},

	mounted() {
		this.$mitt.on('podcastDetails', (e) => this.openModal(e))
	},

	beforeDestroy() {
		this.$mitt.off('podcastDetails')
	},
}
</script>

<style lang="scss" scoped>
.title {
	line-height: 1rem;
	font-size: 18px;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.description {
	line-height: 1rem;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
@media (min-width: $breakpoint-sm-min) {
	.card-main {
		min-width: 70vw;
		width: 70vw;
		height: 85vh;
	}
	.card-player {
		width: 70%;
	}
}
@media (min-width: $breakpoint-lg-min) {
	.card-main {
		min-width: 55vw;
		width: 55vw;
		height: 80vh;
	}
	.card-player {
		width: 85%;
	}
}
.title-audio {
	line-height: 11px;
	word-wrap: break-word;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.date {
	font-size: 0.5rem;
}
.card-player {
	margin: 0 auto;
}
</style>
